import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const ProfileHighlights = ({ candidate }) => {
  const { t } = useTranslation();
  const hasSkills = Array.isArray(candidate?.skills) && candidate.skills.length > 0;
  const hasCertifications = Boolean(candidate?.additionalActivity);

  if (!hasSkills && !hasCertifications) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-elevation-sm">
      <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-4 md:mb-6">
        {t('candidateProfile.profileHighlights')}
      </h2>
      <div className="space-y-4 md:space-y-6">
        {hasSkills && (
          <div>
            <div className="flex items-center gap-2 mb-2 md:mb-3">
              <Icon name="Code" size={20} className="text-primary" />
              <h3 className="text-base md:text-lg font-medium text-foreground">{t('candidateProfile.skills')}</h3>
            </div>
            <div className="flex flex-wrap gap-2 ml-7">
              {candidate.skills.map((skill, index) => (
                <span
                  key={index}
                  className="px-3 py-1.5 bg-muted text-foreground text-xs md:text-sm rounded-full border border-border"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}

        {hasCertifications && (
          <div>
            <div className="flex items-center gap-2 mb-2 md:mb-3">
              <Icon name="FileText" size={20} className="text-success" />
              <h3 className="text-base md:text-lg font-medium text-foreground">{t('candidateProfile.certifications')}</h3>
            </div>
            <p className="text-sm md:text-base text-primary font-semibold ml-7">
              {candidate.additionalActivity}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileHighlights;
